import type { Job } from '@volt/shared';

export interface JobTile {
  key: string;
  job: Job;
  resultUrls: string[];
  resultUrl: string | null;
  resultIndex: number;
}

/**
 * Flattens a job list into one grid tile per result URL (images/videos), so
 * a job with several outputs renders as several tiles. Jobs without a result
 * yet (pending/processing) or that failed produce a single placeholder tile
 * so their status/error can still be shown in the grid.
 */
export function buildJobTiles(jobs: Job[]): JobTile[] {
  const tiles: JobTile[] = [];
  for (const job of jobs) {
    const urls =
      Array.isArray(job.resultUrls) && job.resultUrls.length > 0
        ? job.resultUrls
        : job.resultUrl
          ? [job.resultUrl]
          : [];
    if (urls.length === 0) {
      tiles.push({ key: job.id, job, resultUrls: urls, resultUrl: null, resultIndex: 0 });
    } else {
      urls.forEach((url, index) => {
        tiles.push({ key: `${job.id}-${index}`, job, resultUrls: urls, resultUrl: url, resultIndex: index });
      });
    }
  }
  return tiles;
}
